export interface FeatureSection {
  title: string;
  type: "text" | "list";
  content: string[];
}

export interface FeatureDetail {
  title: string;
  description: string;
  overview: string[];
  sections: FeatureSection[];
  image?: string;
}

export const rawFeatures: FeatureDetail[] = [
  {
    title: "Lėtinis nuovargis",
    description: "Kodėl neturite energijos ir ką daryti?",
    overview: [
      "Mes nesiekiame motyvuoti ar pasiūlyti universalių patarimų. Mūsų tikslas - suprasti, kas konkrečiai mažina jūsų energiją, ir remiantis tuo sudaryti aiškų, praktiškai įgyvendinamą 12 savaičių gyvensenos korekcijos planą su pakartotiniu įvertinimu.",
    ],
    sections: [
      {
        title: "Kam tai aktualu",
        type: "list",
        content: [
          "Jaučiatės pavargę net ir po miego",
          "Energija dienos metu svyruoja, sunku išlaikyti dėmesį",
          "Prastas atsistatymas po fizinio krūvio ar streso",
          "Jau bandėte papildus, rutinos pokyčius, bet rezultato nėra",
        ],
      },
      {
        title: "Ką vertina Telomera",
        type: "list",
        content: [
          "Klinikinius kraujo rodiklius, susijusius su energija ir atsistatymu",
          "Genetinį profilį, padedantį suprasti individualius organizmo ypatumus",
          "Gyvenimo ritmo kontekstą (miegas, fizinis krūvis, mityba, streso lygis)",
        ],
      },
      {
        title: "Ką gaunate",
        type: "list",
        content: [
          "Aiškų atsakymą, kas labiausiai mažina jūsų energiją",
          "Prioritetų planą - nuo ko pradėti, kad pokytis būtų realus",
          "Stebėseną ir aiškumą, ką kartoti bei kada, kad rezultatas išliktų ilgalaikis.",
        ],
      },
    ],
  },
  {
    title: "Raumenų jėga",
    description: "Kaip įvertinti fizinę būklę ir gerinti sveikatą?",
    overview: [
      "Raumenų jėga yra vienas svarbiausių fizinės būklės rodiklių. Ji susijusi susijusi su geresne metaboline sveikata, mažesne traumų ir kritimų rizika bei tuo, kaip lengvai jaučiatės kasdienėje veikloje.",
    ],
    sections: [
      {
        title: "Kam tai aktualu",
        type: "list",
        content: [
          "Norite jaustis stipresni ir geriau kontroliuoti savo kūną",
          "Greitai pavargstate nuo fizinės veiklos ar kasdienių darbų",
          "Siekiate sumažinti traumų riziką arba jau susiduriate su pasikartojančiais skausmais",
          "Norite aiškių, individualiai pritaikytų gairių, nuo ko pradėti",
        ],
      },
      {
        title: "Ką mes vertiname",
        type: "list",
        content: [
          "Esamą jėgos lygį ir raumeninę masę",
          "Jėgos pokytį programos eigoje",
          "Kaip jėga dera su kūno sudėtimi, ištverme ir bendru fiziniu pajėgumu",
        ],
      },
      {
        title: "Ko galite tikėtis Telomeroje",
        type: "list",
        content: [
          "Pirmiausia pamatuojame jėgą ir paaiškiname, ką šie rodikliai reiškia jūsų sveikatai bei kasdieniam funkcionavimui.",
          "Sudarome aiškią veiksmų kryptį - kaip didinti jėgą saugiai, derinant pratimus, progresiją ir atsistatymą. Laikui bėgant matavimus kartojame ir vertiname realų pokytį.",
        ],
      },
    ],
  },
  {
    title: "Ištvermės rezervas (VO₂max)",
    description: "Kaip pagerinti ištvermę ir atsistatymą?",
    overview: [
      "VO₂max yra vienas tiksliausių rodiklių, parodančių organizmo gebėjimą dirbti ilgiau ir atsistatyti greičiau. Jis atspindi, kaip efektyviai kūnas naudoja deguonį fizinio krūvio metu, ir leidžia suprasti ne tik dabartinį ištvermės lygį, bet ir realias progreso galimybes.",
    ],
    sections: [
      {
        title: "Kam tai aktualu",
        type: "list",
        content: [
          "Greitai pavargstate ir sunku išlaikyti pastovų tempą",
          "Treniruojatės reguliariai, tačiau progresas jaučiamas lėtai",
          "Po fizinio krūvio ilgai išlieka nuovargis",
          "Norite treniruotis pagal aiškias, duomenimis paremtas gaires",
        ],
      },
      {
        title: "Ką parodo VO₂max testas",
        type: "list",
        content: [
          "Jūsų aerobinio pajėgumo lygį, arba ištvermės rezervą",
          "Kaip efektyviai organizmas naudoja deguonį krūvio metu",
          "Dabartinį fizinį lygį ir galimą progreso kryptį",
        ],
      },
      {
        title: "Ką gaunate",
        type: "list",
        content: [
          "Aiškų atskaitos tašką, kur esate šiandien",
          "Suprantamas intensyvumo gaires, kaip treniruotis efektyviau",
          "Objektyvų progreso vertinimą laikui bėgant",
        ],
      },
    ],
  },
  {
    title: "Autoimuninės ligos",
    description: "Kaip mažinti paūmėjimus ir stabilizuoti savijautą?",
    overview: [
      "Autoimuninės būklės dažnai pasižymi savijautos svyravimais - periodais, kai jaučiatės geriau, ir laikotarpiais, kai simptomai sustiprėja be aiškios priežasties. Dažniausiai tai susiję ne su vienu veiksniu, o su bendru organizmo krūviu - miego kokybe, stresu, uždegiminiu fonu, mityba ir atsistatymo galimybėmis.",
    ],
    sections: [
      {
        title: "Kam tai aktualu",
        type: "list",
        content: [
          "Savijauta keičiasi bangomis, sunku numatyti pablogėjimus",
          "Norite sumažinti paūmėjimų dažnį ar jų intensyvumą",
          "Ieškote aiškumo, kurie kasdieniai veiksniai stiprina simptomus",
        ],
      },
      {
        title: "Ką mes vertiname",
        type: "list",
        content: [
          "Uždegiminius rodiklius ir imuninę sistemą pagal laboratorinius rodiklius",
          "Mikroelementų rezervus, svarbius atsistatymui",
          "Miego kokybę ir bendrą atsistatymo lygį",
          "Streso apkrovą",
          "Fizinio krūvio toleranciją ir atsistatymo dinamiką",
        ],
      },
      {
        title: "Ką gaunate",
        type: "list",
        content: [
          "Mažiau spėjimų ir daugiau aiškumo, kas provokuoja simptomus",
          "Stabilizavimo strategiją, apimančią miegą, stresą, mitybą bei krūvį",
          "Planą su nuoseklia stebėsena ir korekcijomis",
        ],
      },
    ],
  },
  {
    title: "Lėtinės ligos",
    description: "Kaip pritaikyti gyvenseną, kad stabilizuoti simptomus?",
    overview: [
      "Sergant lėtine liga, bendri patarimai dažnai neveikia. Mes pritaikome mitybą, krūvį, miegą ir stresą taip, kad sumažėtų simptomų svyravimai ir pagerėtų atsistatymas.",
    ],
    sections: [
      {
        title: "Kam tai aktualu",
        type: "list",
        content: [
          "Savijauta svyruoja - vienu laikotarpiu jaučiatės gerai, kitu simptomai sustiprėja",
          "Nerimaujate, kad netinkami pokyčiai gali pabloginti būklę",
          "Norite aiškumo, ką galite daryti saugiai ir ko geriau vengti",
        ],
      },
      {
        title: "Ką mes vertiname",
        type: "list",
        content: [
          "Simptomų dinamiką ir galimus juos provokuojančius veiksnius",
          "Pagrindinius kraujo rodiklius ir su būkle susijusius rizikos signalus",
          "Atsistatymo kokybę - miegą ir krūvio toleranciją",
        ],
      },
      {
        title: "Ko galite tikėtis Telomeroje",
        type: "list",
        content: [
          "Sudarome 12 savaičių planą su aiškiais prioritetais - mitybos, judėjimo, miego ir streso srityse. Po programos pakartotinai vertiname svarbiausius rodiklius, kad sprendimai būtų paremti realiu organizmo atsaku.",
          "Esant poreikiui, rekomenduojame papildomą ištyrimą ar konkretaus specialisto konsultaciją.",
        ],
      },
    ],
  },
  {
    title: "Elgesys ir priklausomybės",
    description: "Kaip nutraukti pasikartojantį ciklą ir išlaikyti kontrolę?",
    overview: [
      "Daugeliu pasikartojančio elgesio atvejų tai yra organizmo reakcija į nuovargį, stresą ar emocinę apkrovą. Kai atsistatymo rezervai sumažėja, sprendimus vis dažniau perima automatiniai įpročiai - nikotinas, cukrus, alkoholis ar kitos kompulsijos tampa greitu būdu sumažinti įtampą.",
    ],
    sections: [
      {
        title: "Kam tai aktualu",
        type: "list",
        content: [
          "Pastebite, kad kartojasi tas pats elgesys, nors norėtumėte jį keisti",
          "Po pasikartojimų atsiranda kaltės ar „užstrigimo“ jausmas",
          "Bandėte keisti įpročius, tačiau pokytis neišsilaiko ilgai",
          "Ieškote aiškaus, praktiško sprendimo be spaudimo ar vertinimo",
        ],
      },
      {
        title: "Ką vertiname",
        type: "list",
        content: [
          "Genetinį polinkį į impulsyvumą ar priklausomybių riziką (kaip kryptį, o ne kaip nuosprendį)",
          "Miego kokybę, streso lygį ir nuovargį, kurie dažnai įjungia automatinį elgesį",
          "Ciklo struktūrą - kada jis prasideda, kas jį sustiprina ir kas padeda jį nutraukti",
        ],
      },
      {
        title: "Ką gaunate",
        type: "list",
        content: [
          "Aiškų kritinių momentų planą, pritaikytą jūsų kasdienybei",
          "Paprastą rutinos struktūrą savaitei ir aiškią „grįžimo“ taisyklę po paslydimo",
          "Daugiau kontrolės kasdienybėje ir mažiau sugrįžimų į senus įpročius",
        ],
      },
    ],
  },
  {
    title: "Vaistų pritaikomumas",
    description: "Kaip pritaikyti vaistus būtent jums?",
    overview: [
      "Įvertiname farmakogenetiką (vaistų skaidymą/jautrumą), toleravimą ir sąveikas, kad turėtumėte aiškų pagrindą saugesniems sprendimams.",
    ],
    sections: [
      {
        title: "Kam tai aktualu",
        type: "list",
        content: [
          "Vaistas neveikia taip, kaip buvo tikėtasi",
          "Pasireiškia šalutiniai poveikiai",
          "Vartojate kelis vaistus ar papildus ir norite aiškumo dėl jų suderinamumo",
          "Norite geriau suprasti, kaip jūsų organizmas reaguoja į gydymą",
        ],
      },
      {
        title: "Ką vertiname",
        type: "list",
        content: [
          "Genetinę kryptį - ar vaistai skaidomi greičiau, lėčiau, ar gali būti padidėjęs jautrumas",
          "Galimą šalutinių poveikių rizikos kryptį",
          "Vaistų ir maisto papildų suderinamumą kasdienėje praktikoje",
        ],
      },
      {
        title: "Ką gaunate",
        type: "list",
        content: [
          "Aiškią vieno puslapio santrauką apie galimas sąveikas ir rizikas",
          "Konkretų klausimų sąrašą vizitui pas gydytoją",
          "Daugiau aiškumo, kaip saugiai vartoti vaistus kasdienybėje",
        ],
      },
    ],
  },
  {
    title: "Gyvensenos pokyčiai",
    description: "Kaip naujus įpročius paversti ilgalaikiu rezultatu?",
    overview: [
      "Dauguma žmonių žino, ką reikėtų keisti - daugiau judėti, geriau miegoti, reguliariai valgyti ar mažinti stresą. Sunkiausia dalis yra ne pradėti, o išlaikyti pokytį tada, kai kasdienybė tampa intensyvi.",
      "Mes gyvensenos pokyčius paverčiame nuosekliu procesu. Sudarome 12 savaičių planą ir stebime objektyvius rodiklius, kad pokytis taptų įpročiu, o ne laikinu bandymu.",
    ],
    sections: [
      {
        title: "Kam tai aktualu",
        type: "list",
        content: [
          "Pradedate keisti įpročius, bet sunku juos išlaikyti",
          "Vienas nukrypimas sugriauna visą savaitės ritmą",
          "Norite plano, kuris būtų pritaikytas realiam gyvenimui, o ne idealioms sąlygoms",
        ],
      },
      {
        title: "Ką sekame",
        type: "list",
        content: [
          "Miegą ir atsistatymą (miego kokybę, HRV kryptį)",
          "Gliukozės stabilumą, kai tai aktualu",
          "Kūno sudėtį",
          "Kraujo rodiklius pagal individualų tikslą (pvz., lipidus, gliukozės kontrolę)",
          "Po 12 savaičių atliekame pakartotinį vertinimą, kad planas būtų koreguojamas pagal realų organizmo atsaką.",
        ],
      },
    ],
  },
  {
    title: "Kūno sudėtis",
    description: "Kaip pamatyti pokytį, kurio svarstyklės nerodo?",
    overview: [
      "Svoris ne visada atspindi realius pokyčius organizme. Savijauta gali blogėti net ir tuomet, kai kilogramai nesikeičia, o kartais svoris mažėja kartu su raumenine mase. Kūno sudėties vertinimas leidžia suprasti riebalų ir raumenų balansą, riebalų pasiskirstymą ir metabolinę riziką. Tai padeda sudaryti planą, kuris gerina ne tik išvaizdą, bet ir ilgalaikę sveikatą.",
    ],
    sections: [
      {
        title: "Kam tai aktualu",
        type: "list",
        content: [
          "Svoris nekinta, tačiau savijauta blogėja",
          "Norite mažinti riebalus neprarasdami raumenų",
          "Norite matyti realų progresą, o ne tik skaičių svarstyklėse",
        ],
      },
      {
        title: "Ką vertiname",
        type: "list",
        content: [
          "Riebalų ir liesos (raumeninės) masės proporcijas",
          "Riebalų pasiskirstymą, ypač pilvo srityje",
          "Visceralinius riebalus - riebalus aplink vidaus organus, kurie labiausiai siejami su metaboline rizika",
          "Pokytį laikui bėgant",
        ],
      },
      {
        title: "Telomera metodas",
        type: "text",
        content: [
          "Pirmiausia aiškiai įvardijame tikslą - ką mažiname ir ką siekiame išsaugoti ar auginti. Tuomet pritaikome mitybos, fizinio krūvio ir atsistatymo kryptį taip, kad keistųsi kūno sudėtis, o ne tik svoris.",
          "Po 12 savaičių matavimą kartojame ir, remdamiesi realiais pokyčiais, tiksliname planą.",
        ],
      },
    ],
  },
  {
    title: "Mikroelementų ir vitaminų pasisavinamumas",
    description: "Kaip atstatyti trūkumus ir pajusti realų pokytį?",
    overview: [
      "Nuovargis, silpnumas ar prastesnis atsistatymas dažnai siejami su vitaminų ar mikroelementų trūkumu. Vien papildų vartojimas ne visada išsprendžia problemą. Kartais organizmas jų nepasisavina, kartais trūkumas nėra tikras, o kartais korekcija tiesiog nėra pritaikyta individualiai situacijai.",
      "Telomeroje pirmiausia siekiame suprasti, kokie rezervai iš tikrųjų sumažėję ir kodėl jie neatsistato. Tik tuomet sudaromas korekcijos planas, orientuotas į pamatuojamą pokytį rodikliuose ir savijautoje.",
    ],
    sections: [
      {
        title: "Kam tai aktualu",
        type: "list",
        content: [
          "Jaučiate nuovargį, silpnumą ar „smegenų rūką“",
          "Atsistatymas lėtas, dažniau kartojasi infekcijos",
          "Vartojate papildus, tačiau nepastebite aiškaus poveikio",
          "Norite suprasti, ko organizmui iš tikrųjų trūksta",
        ],
      },
      {
        title: "Ką vertiname",
        type: "list",
        content: [
          "Pagrindinių rezervų kryptį - feritiną, vitaminą B12, vitaminą D, cinką, elektrolitus ir kitus rodiklius pagal situaciją",
          "Rodiklius, galinčius rodyti pasisavinimo problemą",
          "Situacijas, kai papildai vartojami, tačiau rezervai nekyla arba greitai vėl sumažėja",
          "Genetinę predispoziciją pasisavinimui",
        ],
      },
    ],
  },
  {
    title: "Stresas",
    description: "Kaip stabilizuoti atsistatymą ir emocinį toną?",
    overview: [
      "Stresas savaime nėra problema. Problema atsiranda tuomet, kai organizmas nebespėja grįžti į ramybės būseną. Ilgainiui tai veikia ne tik savijautą, bet ir atsistatymą, koncentraciją bei emocinį stabilumą. Mes vertiname, kaip jūsų organizmas reaguoja į stresą ir kaip greitai atsistato po apkrovos. Sudaromas atsistatymo režimas, kuris padeda stabilizuoti miegą, energiją ir emocinį toną.",
    ],
    sections: [
      {
        title: "Kam tai aktualu",
        type: "list",
        content: [
          "Įtampa išlieka net ir pailsėjus",
          "Jaučiate dirglumą, nerimą ar „perdegimo“ jausmą",
          "Miegas paviršutiniškas, ryte sunku jaustis pailsėjus",
          "Jaučiate, kad organizmas nuolat veikia „aukštesne pavara“",
        ],
      },
      {
        title: "Ką vertiname",
        type: "list",
        content: [
          "Streso hormonus (kortizolį, DHEA-S)",
          "Atsistatymo duomenis - naktinį HRV, ramybės pulsą, miego kokybę",
          "Genetinę predispoziciją streso tolerancijai ir kofeino metabolizmui",
        ],
      },
      {
        title: "Telomera metodas",
        type: "text",
        content: [
          "Remiantis įvertinimu sudarome atsistatymo rekomendacijas - aiškų miego laiką, kofeino vartojimo ribas ir fizinio krūvio apkrovą, kad organizmas turėtų galimybę atsistatyti. Pridedame trumpą, lengvai įgyvendinamą vakaro protokolą (5-10 minučių), kuris padeda sumažinti įtampos piką prieš miegą. Po 12 savaičių vertiname pokytį ir, jei reikia, koreguojame planą.",
        ],
      },
    ],
  },
  {
    title: "Paveldimų ligų rizika",
    description: "Kaip suprasti šeimos rizikas ir veikti iš anksto?",
    overview: [
      "Ne visos paveldėtos rizikos tampa liga, tačiau žinant kryptį galima pasirinkti tinkamą stebėjimą ir prevenciją. Tikslas nėra ieškoti ligos, o suprasti, ką verta stebėti anksčiau ir kaip sumažinti nežinomybę ateityje.",
      "Mūsų genetikai padeda atsirinkti, kas iš genetinės informacijos yra iš tiesų svarbu jūsų situacijai, ir paverčia tai aiškiu, praktišku veiksmų planu.",
    ],
    sections: [
      {
        title: "Kam tai aktualu",
        type: "list",
        content: [
          "Šeimoje buvo onkologinių, širdies ir kraujagyslių, neurologinių ar metabolinių ligų (pvz., infarktai, insultai, Alzheimerio liga, diabetas)",
          "Artimi šeimos nariai susirgo palyginti jauname amžiuje",
          "Norite aiškumo vietoje nuolatinės nežinios",
          "Ieškote konkretaus plano, o ne bendrų interpretacijų internete",
        ],
      },
      {
        title: "Ką vertiname",
        type: "list",
        content: [
          "Klinikinio genomo kryptis - onkologines, širdies ir kraujagyslių, neurodegeneracines, metabolines ir kitas rizikas",
          "Šeimos anamnezę kartu su jūsų esamais rodikliais",
          "Rizikos aktualumą šiandien ir ilgalaikėje perspektyvoje",
        ],
      },
      {
        title: "Telomera metodas",
        type: "list",
        content: [
          "Genetikai atskiria, kurios rizikos yra aktualios dabar, o kurios reikalauja tik periodinės stebėsenos. Remiantis tuo sudaromas prevencijos planas - kokius tyrimus atlikti, kaip dažnai juos kartoti ir į kokius specialistus kreiptis.",
          "Genetinė informacija integruojama su kraujo rodikliais ir gyvensena, kad rekomendacijos būtų praktiškos.",
        ],
      },
    ],
  },
  {
    title: "Aukštas cholesterolis",
    description: "Kaip mažinti širdies ir kraujagyslių ligų riziką?",
    overview: [
      "Padidėjęs cholesterolis dažnai kelia nerimą, tačiau vien tik skaičius neparodo tikrosios rizikos. Skirtingiems žmonėms tas pats rodiklis gali reikšti skirtingą situaciją. Mes vertiname bendrą rizikos kontekstą ir sudarome aiškų veiksmų planą, orientuotą į realų pokytį rodikliuose ir ilgalaikę širdies sveikatą.",
    ],
    sections: [
      {
        title: "Kam tai aktualu",
        type: "list",
        content: [
          "Nustatytas padidėjęs MTL ar bendras cholesterolis ir neaišku, nuo ko pradėti",
          "Šeimoje buvo ankstyvų širdies ar kraujagyslių ligų",
          "Norite aiškaus plano su matomu progresu",
          "Siekiate suprasti, ar rizika susijusi su gyvensena, ar su paveldimumu",
        ],
      },
      {
        title: "Ką vertiname",
        type: "list",
        content: [
          "Lipidogramą (MTL, DTL ir trigliceridus bei jų santykį)",
          "ApoA ir ApoB bei jų santykį, leidžiantį įvertinti aterogeninių (riziką didinančių) dalelių kiekį kraujyje",
          "Lp(a) - paveldimą lipidų frakciją, susijusią su padidėjusia širdies ir kraujagyslių ligų rizika",
          "Genetinę predispoziciją lipidų apykaitai, padedančią suprasti, ar rodikliai labiau susiję su paveldimumu, ar gyvensenos veiksniais",
          "Bendrą metabolinį kontekstą, kuris turi įtakos lipidų pokyčiams ir ilgalaikei širdies rizikai",
        ],
      },
      {
        title: "Telomera metodas",
        type: "list",
        content: [
          "Pirmiausia sudarome individualų rizikos profilį ir išgryniname, kurie veiksniai turi didžiausią įtaką būtent jūsų situacijoje. Parengiame 12 savaičių korekcijos planą, apimantį mitybą, fizinį aktyvumą, miegą ir streso valdymą.",
          "Po šio laikotarpio rodikliai pakartotinai vertinami, o strategija tikslinama pagal realų organizmo atsaką.",
        ],
      },
    ],
  },
  {
    title: "Miegas",
    description: "Kaip atsistatyti taip, kad ryte jaustumėtės pailsėję?",
    overview: [
      "Mes vertiname ne tik miego trukmę, bet ir tai, kaip jūs miegate. Remiantis objektyviais miego rodikliais ir genetine informacija, sudaroma rutina, padedanti pasiekti stabilesnį ir kokybiškesnį atsistatymą.",
    ],
    sections: [
      {
        title: "Kam tai aktualu",
        type: "list",
        content: [
          "Ilgai laukiate, kol užmiegate arba dažnai prabundate naktį",
          "Ryte jaučiatės nepailsėję, nors miegate pakankamai valandų",
          "Jaučiate, kad atsistatymas po dienos ar sporto yra nepakankamas",
        ],
      },
      {
        title: "Ką vertiname",
        type: "list",
        content: [
          "Užmigimo laiką, prabudimus ir bendrą miego efektyvumą",
          "Gilaus ir REM miego dinamiką",
          "Naktinį HRV ir ramybės pulsą, atspindinčius atsistatymo lygį",
          "Chronotipą pagal genetiką, padedantį nustatyti optimalų miego laiką ir trukmę",
        ],
      },
      {
        title: "Ką gaunate",
        type: "list",
        content: [
          "Miego metrikų santrauką ir aiškų režimą",
          "Planą, kuris gerina atsistatymą, o ne tik prailgina laiką lovoje",
        ],
      },
    ],
  },
  {
    title: "Mityba",
    description: "Kokia mityba tinka būtent jums?",
    overview: [
      "Mitybos rekomendacijų šiandien daug, tačiau skirtingi žmonės į tą patį maistą reaguoja nevienodai. Tai, kas vienam padeda jaustis energingiau, kitam gali sukelti energijos svyravimus, virškinimo diskomfortą ar stabdyti progresą keičiant kūno sudėtį.",
      "Mes sujungiame kraujo rodiklius, genetinę informaciją, savijautą ir gyvenimo ritmą, kad mitybos pokyčiai duotų realų rezultatą - stabilesnę energiją, lengvesnį virškinimą ir aiškų progresą.",
    ],
    sections: [
      {
        title: "Kam tai aktualu",
        type: "list",
        content: [
          "Energija dienos metu svyruoja, sunku išlaikyti stabilų ritmą",
          "Svoris ar kūno sudėtis nekinta, nors stengiatės laikytis mitybos režimo",
          "Virškinimas jautrus, po tam tikrų produktų jaučiate diskomfortą",
          "Norite aiškaus plano vietoje prieštaringų patarimų",
        ],
      },
      {
        title: "Ką vertiname",
        type: "list",
        content: [
          "Kraujo rodiklius, parodančius metabolizmo funkciją, uždegimą ir maistinių medžiagų balansą",
          "Genetines predispozicijas, susijusias su maisto toleravimu, sotumu ir reakcija į stimuliatorius, pavyzdžiui, kofeiną",
          "Savijautos dinamiką - energiją, alkio pojūtį, virškinimą ir miegą",
        ],
      },
      {
        title: "Ką gaunate",
        type: "list",
        content: [
          "Mitybos gaires, pritaikytas jūsų gyvenimo ritmui, o ne idealioms sąlygomis",
          "Didesnį aiškumą, kas jūsų organizmui iš tiesų veikia",
        ],
      },
    ],
  },
];
